<template>
	<div class="animated fadeIn">

		<div class="row mb10">
			<div class="col-xs-12 clearfix">

				<div class="pull-left f24">
					<i class="fa fa-fire text-success"></i>
					<span>定制页面列表</span>
				</div>

			</div>

			<div class="col-xs-12 mt30">
				<div class="alert alert-warning">
					以下展示的是网站中专题的样式，这些样式可以在 【菜单/专题】中进行链接。如果要添加更多专题样式，请联系程序员进行操作。
				</div>
			</div>

		</div>

		<div class="row">

			<div class="col-xs-12">

				<div v-for="theme in themeList" class="bg-white p10 mt10 br4 cursor">

					<div class="row" @click="previewClick(theme)">

						<div class="col-sm-12">
							<div class="media">
								<div class="pull-left">
								</div>
								<div class="media-body">
									<div>
										<span class="f15">{{theme.name}}</span>
									</div>
									<div class="mv5">
										{{theme.description}}
									</div>
									<div class="mv5">
										<span>编号：{{theme.id}}</span>
										<span class="italic"> 点击可以预览 </span>
									</div>
								</div>
							</div>
						</div>

					</div>


				</div>


			</div>

		</div>

	</div>

</template>
<script>

	import {MessageBox, Notification} from 'element-ui'

	export default {

		data () {
			return {}
		},
		components: {},
		computed: {
			"themeList"(){
				return this.$store.state.themeList;
			}
		},
		watch: {},
		methods: {
			previewClick(theme){
				window.open("/" + theme.getPreviewLocation());
			}
		},
		mounted(){

		}
	}

</script>



// WEBPACK FOOTER //
// List.vue?0f89f5cf